<template>
  <div class="modelsindex container">
    <el-row>
      <el-col :span="4">
        <router-link
          tag="a"
          :to="{
                  name:'Everxyz',
                        
                }"
        >
          <el-button type="primary">上传报价</el-button>
        </router-link>
      </el-col>
    </el-row>
    <el-tabs :tab-position="tabPosition">
      <el-tab-pane label="3D打印">
        <ul class="flex">
          <li v-for="(item,index) in modelsArr1" :key="index">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <img :src="item.img[0]" class="image" />
              <div style="padding: 14px;">
                <span v-text="'材料：' + item.name"></span>
                <div class="bottom clearfix">
                  <div class="color lie" v-text="'颜色:'+item.color" v-show="!!item.color"></div>
                  <div class="tolerance" v-text="'公差:' + item.tolerance" v-show="!!item.tolerance"></div>
                  <div class="time lie" v-text="item.setDate"></div>
                  <div class="button">
                    <el-button
                      type="text"
                      style="padding-bottom:0;"
                      @click="mouldsInfo(item.id)"
                    >查看详情</el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="金属打样及批量">
        <ul class="flex">
          <li v-for="(item,index) in modelsArr2" :key="index">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <img :src="item.img[0]" class="image" />
              <div style="padding: 14px;">
                <span v-text="'材料：' + item.name"></span>
                <div class="bottom clearfix">
                  <div class="color lie" v-text="'颜色:'+item.color" v-show="!!item.color"></div>
                  <div class="tolerance" v-text="'公差:' + item.tolerance" v-show="!!item.tolerance"></div>
                  <div class="time lie" v-text="item.setDate"></div>
                  <div class="button">
                    <el-button
                      type="text"
                      style="padding-bottom:0;"
                      @click="mouldsInfo(item.id)"
                    >查看详情</el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="模具制造">
        <ul class="flex">
          <li v-for="(item,index) in modelsArr3" :key="index">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <img :src="item.img[0]" class="image" />
              <div style="padding: 14px;">
                <span v-text="'材料：' + item.name"></span>
                <div class="bottom clearfix">
                  <div class="color lie" v-text="'颜色:'+item.color" v-show="!!item.color"></div>
                  <div class="tolerance" v-text="'公差:' + item.tolerance" v-show="!!item.tolerance"></div>
                  <div class="time lie" v-text="item.setDate"></div>
                  <div class="button">
                    <el-button
                      type="text"
                      style="padding-bottom:0;"
                      @click="mouldsInfo(item.id)"
                    >查看详情</el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="大批量注塑">
        <ul class="flex">
          <li v-for="(item,index) in modelsArr4" :key="index">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <img :src="item.img[0]" class="image" />
              <div style="padding: 14px;">
                <span v-text="'材料：' + item.name"></span>
                <div class="bottom clearfix">
                  <div class="color lie" v-text="'颜色:'+item.color" v-show="!!item.color"></div>
                  <div class="tolerance" v-text="'公差:' + item.tolerance" v-show="!!item.tolerance"></div>
                  <div class="time lie" v-text="item.setDate"></div>
                  <div class="button">
                    <el-button
                      type="text"
                      style="padding-bottom:0;"
                      @click="mouldsInfo(item.id)"
                    >查看详情</el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "ModelsIndex",
  data() {
    return {
      tabPosition: "left",
      modelsArr1: [],
      modelsArr2: [],
      modelsArr3: [],
      modelsArr4: []
    };
  },
  methods: {
    getMoulds() {
      this.$http
        .get("/v2/GetMoulds")
        .then(res => {
          this.modelsArr1 = res.data.moulds_3d;
          this.modelsArr2 = res.data.moulds_dy;
          this.modelsArr3 = res.data.moulds_make;
          this.modelsArr4 = res.data.moulds_injection;
        })
        .catch(error => {});
    },
    mouldsInfo(e) {
      this.$router.push({
        name: "ModelsPage",
        query: {
          id: e
        }
      });
    }
  },
  created() {
    this.getMoulds();
  }
};
</script>

<style scoped>
.modelsindex {
  padding: 35px 0;
}
.modelsindex ul {
  flex-wrap: wrap;
}
.modelsindex ul li {
  width: calc(100% / 4);
  padding: 15px 15px;
  box-sizing: border-box;
}
.modelsindex .lie {
  margin-top: 5px;
}
</style>